{
  "corporatePortal": {
    "corporateDetails": {
      "header": "Yritystilin tiedot",
      "edit": "Muuta yritystietoja"
    }
  }
}
